import { Asset } from '@cibo/core'
import { Skeleton, useTheme } from '@mui/material'
import { useSponsorOrganizationContent } from '../../queries'

interface BrandLogoProps {
  altText?: string
  sponsorOrgId?: string
  logoStyle?: any
  size?: 'small' | 'large'
  variant?: 'square' | 'default'
}

const LOGO_FIELD = {
  default: {
    dark: 'logoDarkLarge',
    light: 'logoLightLarge',
  },
  square: {
    dark: 'logoDarkSquare',
    light: 'logoLightSquare',
  },
} as const

export const BrandLogo = ({
  altText,
  sponsorOrgId,
  logoStyle,
  size,
  variant = 'default',
}: BrandLogoProps) => {
  const theme = useTheme()

  const width =
    !size && !!logoStyle?.width && typeof logoStyle.width === 'number'
      ? logoStyle.width
      : size === 'small'
      ? 60
      : 100
  const height =
    !!logoStyle?.height && typeof logoStyle.height === 'number' ? logoStyle.height : undefined

  const orgContent = useSponsorOrganizationContent({
    orgId: sponsorOrgId,
  })

  const logoVariant = LOGO_FIELD[variant][theme.palette.mode]
  const logoModelFields = (orgContent.data?.fields[logoVariant] as Asset | undefined)?.fields

  if (orgContent.isPending || orgContent.isFetching || orgContent.isError) {
    return <Skeleton height={32} width={width} />
  }
  if (!logoModelFields || !logoModelFields.file) {
    return null
  }

  const url = logoModelFields.file.url

  const sourceSet = !!height
    ? `${url}?h=${height}, ${url}?h=${height * 2} 2x, ${url}?h=${height * 3} 3x`
    : `${url}?w=${width}, ${url}?w=${width * 2} 2x, ${url}?w=${width * 3} 3x`

  return (
    <img
      alt={altText || logoModelFields.description}
      src={url}
      srcSet={sourceSet}
      style={{ width, objectFit: 'contain', ...logoStyle }}
    />
  )
}
